import {
  UPLOADCHIADATA_COUNT_ASSIGN_SUCCESS,
  UPLOADCHIADATA_HISTORY_LIST_SUCCESS,
  UPLOADCHIADATA_IMPORT_SUCCESS,
  UPLOADCHIADATA_LIST_SUCCESS,
  UPLOADCHIADATA_LIST_FAILD,
  UPLOADCHIADATA_NEW_CARE_SUCCESS,
  UPLOADCHIADATA_ONE_SUCCESS,
  UPLOADCHIADATA_SAVE_SUCCESS,
  UPLOADCHIADATA_OPTION_DATA_BRANCH_SUCCESS,
  UPLOADCHIADATA_OPTION_DATA_LEADER_SUCCESS,
  UPLOADCHIADATA_OPTION_DATA_SALE_SUCCESS,
  UPLOADCHIADATA_UPDATE_FILTER,
} from 'src/actions/uploadchiadata.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_handlescannumbers: [],
}

const uploadchiadataReducer = (state = initState, action) => {
  switch (action.type) {
    case UPLOADCHIADATA_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case UPLOADCHIADATA_OPTION_DATA_BRANCH_SUCCESS: {
      return {
        ...state,
        option_data_branch: action.data,
      }
    }
    case UPLOADCHIADATA_OPTION_DATA_LEADER_SUCCESS: {
      return {
        ...state,
        option_data_leader: action.data,
      }
    }
    case UPLOADCHIADATA_OPTION_DATA_SALE_SUCCESS: {
      return {
        ...state,
        option_data_sale: action.data,
      }
    }
    case UPLOADCHIADATA_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case UPLOADCHIADATA_LIST_FAILD: {
      return {
        ...state,
        items: [],
        total: 0,
      }
    }
    case UPLOADCHIADATA_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case UPLOADCHIADATA_SAVE_SUCCESS: {
      return {
        ...state,
        temp_handlescannumbers: []
      }
    }
    default: {
      return state;
    }
  }
}
export default uploadchiadataReducer